import { FunctionComponent } from "react";

// styles
import UnitDropdown from "./unit-dropdown";
import OrganizationDropdown from "./organization-dropdown";
import {
  StyledContainer,
  Wrapper,
  StyledCol,
  StyledRow,
} from "./unit-selection.styles";

const UnitSelection: FunctionComponent<any> = () => {
  return (
    <Wrapper>
      <StyledContainer>
        <StyledRow>
          <StyledCol>
            <OrganizationDropdown />
          </StyledCol>
          <StyledCol>
            <UnitDropdown />
          </StyledCol>
        </StyledRow>
      </StyledContainer>
    </Wrapper>
  );
};

export default UnitSelection;
